import React from 'react';
import Contact from '../Contact';

export const Customer = () => {
  const styles = {
    container: {
      minHeight: '100vh',
      backgroundColor: '#f8f9fa',
      padding: '40px 20px'
    },
    header: {
      textAlign: 'center',
      marginBottom: '50px'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
      color: '#2c3e50',
      marginBottom: '15px'
    },
    subtitle: {
      fontSize: '1.1rem',
      color: '#7f8c8d'
    },
    card: {
      backgroundColor: 'white',
      borderRadius: '12px',
      padding: '30px',
      boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      marginBottom: '30px'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: '600',
      color: '#2c3e50',
      marginBottom: '20px',
      borderBottom: '3px solid #3498db',
      paddingBottom: '10px'
    },
    faqItem: {
      marginBottom: '20px',
      padding: '15px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      borderLeft: '4px solid #3498db'
    },
    faqQuestion: {
      fontWeight: '600',
      color: '#2c3e50',
      marginBottom: '8px',
      fontSize: '1.05rem'
    },
    faqAnswer: {
      color: '#7f8c8d',
      lineHeight: '1.6'
    },
    contactMethod: {
      display: 'flex',
      alignItems: 'center',
      padding: '20px',
      backgroundColor: '#f8f9fa',
      borderRadius: '8px',
      marginBottom: '15px'
    },
    contactIcon: {
      fontSize: '2rem',
      marginRight: '20px',
      color: '#3498db'
    },
    contactInfo: {
      flex: 1
    },
    contactTitle: {
      fontWeight: '600',
      color: '#2c3e50',
      marginBottom: '5px'
    },
    contactDetail: {
      color: '#7f8c8d',
      marginBottom: '3px'
    },
    row: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: '0 -15px'
    },
    col: {
      flex: '0 0 100%',
      maxWidth: '100%',
      padding: '0 15px',
      boxSizing: 'border-box'
    },
    infoSection: {
      marginBottom: '25px'
    },
    infoText: {
      color: '#555',
      lineHeight: '1.8',
      fontSize: '1rem',
      marginBottom: '15px'
    },
    hoursTable: {
      width: '100%',
      marginTop: '15px'
    },
    hoursRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '10px 0',
      borderBottom: '1px solid #e0e0e0'
    },
    dayLabel: {
      fontWeight: '500',
      color: '#2c3e50'
    },
    timeLabel: {
      color: '#7f8c8d'
    }
  };

  const colStyle = window.innerWidth >= 768 ? {
    ...styles.col,
    flex: '0 0 50%',
    maxWidth: '50%'
  } : styles.col;

  return (
    <>
     
    <br />
    <br />
    <br />
    <div style={styles.container}>
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={styles.header}>
          <h1 style={styles.title}>Customer Support</h1>
          <p style={styles.subtitle}>We're here to help! Find answers to common questions and learn how to reach us.</p>
        </div>

        <div style={styles.row}>
         <div style={colStyle}>
            <div style={styles.card}>
              <h2 style={styles.sectionTitle}>Contact Information</h2>
              
              <div style={styles.infoSection}>
                <p style={styles.infoText}>
                  Our dedicated support team is ready to assist you with any questions or concerns. 
                  We offer multiple ways to get in touch based on your preference and urgency.
                </p>
              </div>

              <div style={styles.contactMethod}>
                <div style={styles.contactIcon}>📧</div>
                <div style={styles.contactInfo}>
                  <div style={styles.contactTitle}>Email Support</div>
                  <div style={styles.contactDetail}>support@foxtroit.in</div>
                  <div style={styles.contactDetail}>Response time: Within 24 hours</div>
                </div>
              </div>

              <div style={styles.contactMethod}>
                <div style={styles.contactIcon}>📞</div>
                <div style={styles.contactInfo}>
                  <div style={styles.contactTitle}>Phone Support</div>
                  <div style={styles.contactDetail}>+91 9861632429</div>
                  <div style={styles.contactDetail}>Mon-Fri: 10:00 AM - 6:00 PM IST</div>
                </div>
              </div>


              <div style={styles.contactMethod}>
                <div style={styles.contactIcon}>📍</div>
                <div style={styles.contactInfo}>
                  <div style={styles.contactTitle}>Office Address</div>
                  <div style={styles.contactDetail}>MR building, 3rd floor</div>
                  <div style={styles.contactDetail}> Hbr layout, Hennur Cross</div>
                  <div style={styles.contactDetail}>Bangalore, Karnataka, 560043, India</div>
                </div>
              </div>
            </div>
          </div>

         <div style={colStyle}>
  <div style={styles.card}>

    <div style={styles.faqItem}>
      <div style={styles.faqQuestion}>1. Support Channels</div>
      <div style={styles.faqAnswer}>
        You can reach our support team via:<br /><br />
        📧 <strong>Email:</strong> support@foxtroit.in <br />91 9861632429<br />
      </div>
    </div>

    <div style={styles.faqItem}>
      <div style={styles.faqQuestion}>2. Response Time(All Working Days)</div>
      <div style={styles.faqAnswer}>
        Our standard response time is:<br /><br />
        • Within <strong>24 hours</strong> for general inquiries<br />
        • Within <strong>4–6 hours</strong> for urgent operational issues<br />
        • <strong>Immediate acknowledgment</strong> for technical failures or service downtime
      </div>
    </div>

    <div style={styles.faqItem}>
      <div style={styles.faqQuestion}>3. Scope of Support</div>
      <div style={styles.faqAnswer}>
        Our support includes:<br /><br />
        • Assistance with setup, integration, and product usage<br />
        • Troubleshooting technical or AI model-related issues<br />
        • Providing updates, patches, or new releases<br />
        • Addressing security or performance concerns
      </div>
    </div>

    <div style={styles.faqItem}>
      <div style={styles.faqQuestion}>4. Service Hours</div>
      <div style={styles.faqAnswer}>
        Support is available <strong>Monday to Friday</strong>, <strong>10:00 AM – 6:00 PM IST</strong>.<br />
        For emergencies or critical outages, our AI monitoring system will automatically notify the technical team for prompt response.
      </div>
    </div>

  </div>
</div>

        </div>
      </div>
    </div>
    <Contact />
    </>
  );
};

export default Customer;